import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import ServicesPage from './pages/ServicesPage';
import PortfolioPage from './pages/PortfolioPage';
import ProcessPage from './pages/ProcessPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import CafePage from './pages/CafePage';
import EchoxPage from './pages/EchoxPage';
import PayupPage from './pages/PayupPage';
import SolunePage from './pages/SolunePage';
import WebmailRedirect from './pages/WebmailRedirect';
import AdminPage from './pages/AdminPage';
import { ParticleTextEffect } from './components/ui/particle-text-effect';

const MainLayout = () => (
  <>
    <Navbar />
    <main className="flex-grow"><Outlet /></main>
    <Footer />
  </>
);

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname === '/admin';
  const [isLoading, setIsLoading] = useState(!isAdmin);

  return (
    <div className="min-h-screen bg-slate-50 font-sans selection:bg-indigo-500 selection:text-white flex flex-col relative">
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Route>
        <Route path="/portfolio/cafe" element={<CafePage />} />
        <Route path="/portfolio/echox" element={<EchoxPage />} />
        <Route path="/portfolio/payup" element={<PayupPage />} />
        <Route path="/portfolio/solune" element={<SolunePage />} />
        <Route path="/webmail" element={<WebmailRedirect />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      {!isLoading && !isAdmin && <WhatsAppButton />}
      {isLoading && !isAdmin && <ParticleTextEffect onComplete={() => setIsLoading(false)} />}
    </div>
  );
}

export default function App() {
  return <Router><AppContent /></Router>;
}